module.exports = __webpack_public_path__ + "img/waistband button diameter.965cd611.png";